import { render } from "./RetiradaMaterial.vue?vue&type=template&id=4cd9e2d2&scoped=true"
import script from "./RetiradaMaterial.vue?vue&type=script&lang=js"
export * from "./RetiradaMaterial.vue?vue&type=script&lang=js"

import "./RetiradaMaterial.vue?vue&type=style&index=0&id=4cd9e2d2&lang=css"
import "./RetiradaMaterial.vue?vue&type=style&index=1&id=4cd9e2d2&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd9e2d2"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QVideo from 'quasar/src/components/video/QVideo.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QVideo,QSelect,QTable,QBtn,QTd,QInput,QTooltip,QImg,QPagination,QDialog,QCard,QCardSection,QSeparator,QCardActions,QTabs,QTab,QTabPanels,QTabPanel,QBadge,QField});qInstall(script, 'directives', {ClosePopup});
